// import React, { useRef, useState } from 'react';
// import styles from './DateSelect.module.css';
// import { IoCalendarClearOutline } from 'react-icons/io5';
// import CandleCalendar from './CandleCalendar';

// const DateSelect = props => {
//   const { name, label, required, defaultValue, valueInput } = props || {};
//   const dateInputRef = useRef(null);

//   const [startDate, setStartDate] = useState('');

//   // Define dates you want to disable in YYYY-MM-DD format
//   const disabledDates = [
//     '2024-11-29', // November 29, 2024
//     '2024-11-30', // November 30, 2024
//     // Add more dates as needed
//   ];

//   // Handle date change
//   const handleDateChange = e => {
//     const selectedDate = e.target.value;

//     // Check if the selected date is in the disabledDates array
//     if (disabledDates.includes(selectedDate)) {
//       alert('This date is disabled. Please choose another date.');
//       setStartDate(''); // Reset the date if it's in the disabled list
//     } else {
//       setStartDate(selectedDate); // Update state with valid date
//     }
//   };

//   return (
//     <div className={styles.dateSelectContainer}>
//       <span
//         className={styles.dateLabel}
//         onClick={() => dateInputRef.current && dateInputRef.current.focus()} // Focus input on label click
//       >
//         {label} {required && <span className={styles.required}>*</span>}
//       </span>
//       <div className={styles.inputDateContainer}>
//         <input
//           type="date"
//           id={name || 'date-input'}
//           name={name || 'date-input'}
//           ref={dateInputRef}
//           value={startDate} // Control value via state
//           onChange={handleDateChange} // Validate date on change
//           className={styles.dateInput}
//           min="2024-01-01"
//           max="2024-12-31"
//         />
//         <div className={style.}>
//           <CandleCalendar />
//         </div>

//         {/* <div
//           onClick={() => dateInputRef.current && dateInputRef.current.focus()}
//           className={styles.inputPlaceholder}
//         >
//           {valueInput}
//           <IoCalendarClearOutline />
//         </div> */}
//       </div>
//     </div>
//   );
// };

// export default DateSelect;

import React, { useEffect, useRef, useState } from 'react';
import { Field } from 'react-final-form';
import styles from './DateSelect.module.css';
import { IoCalendarClearOutline } from 'react-icons/io5';
import CandleCalendar from './CandleCalendar';

const DateSelect = props => {
  const {
    name,
    label,
    required,
    meta,
    defaultValue,
    value,
    valueInput,
    onChange,
    currentDate,
    monthlyTimeSlots,
  } = props || {};
  const dateInputRef = useRef(null);
  const [showDiv, setShowDiv] = useState(false);
  const handleLabelClick = () => {
    setShowDiv(!showDiv);
  };


  const onClose = () => {
    setShowDiv(false);
  };
  const divRef = useRef(null);
  useEffect(() => {
    // Function to handle click events
    const handleClickOutside = event => {
      if (divRef.current && !divRef.current.contains(event.target)) {
        // If click is outside, set showDiv to false
        setShowDiv(false);
      }
    };

    // Add event listener for clicks
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setShowDiv]);
  return (
    <div className={styles.dateSelectContainer}>
      <span
        className={styles.dateLabel}
        onClick={handleLabelClick} // Focus input on label click
      >
        {label} {required && <span className={styles.required}>*</span>}
      </span>
      <div className={styles.inputDateContainer}>
        <input
          id="inputId"
          name={name || 'inputId'}
          ref={dateInputRef} // Attach the ref to the input
          {...props}
          type="date"
          className={styles.dateInput}
        />
        <div onClick={handleLabelClick} className={styles.inputPlaceholder}>
          {/* {dateInputRef?.current?.value} : {props?.defaultValue} */} {valueInput}
          <IoCalendarClearOutline />
        </div>
        {showDiv && (
          <div className={styles.container_CandleCalendar}>
            <CandleCalendar
              divRef={divRef}
              onChange={onChange}
              onClose={onClose}
              currentDate={currentDate}
              monthlyTimeSlots={monthlyTimeSlots}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DateSelect;
